import { useEffect, useState } from "react";
import { AnimateOnScroll, Paragraph, PrimaryButton } from "../../components";
import "./join_page.scss";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";

const JoinPage = () => {
  const [signedPeople, setSignedPeople] = useState<number>();
  const [counter, setCounter] = useState<number>(0);
  const [animateNumber, setAnimateNumber] = useState(false);

  useEffect(() => {
    if (!signedPeople || (!animateNumber && counter === 0)) return;

    if (counter < signedPeople) {
      let timing = Math.pow(counter / signedPeople, 10);

      setTimeout(() => setCounter(counter + 1), timing * 300);
    }
  }, [animateNumber, signedPeople, counter, setCounter]);

  useEffect(() => {
    onSnapshot(doc(db, "WaitingList/numbers"), (snap) => {
      setSignedPeople(snap.data()?.users);
    });
  }, [setSignedPeople]);

  return (
    <section className="part-page" id="join-section">
      <div id="main-word">
        <h2>
          Rejoins la <span className="highlighted">waiting list,</span>
        </h2>
        <h2>
          Rejoins <span className="highlighted">le projet SWUN</span>
        </h2>
      </div>
      <Paragraph highlighted="SWUN" id="swun-goal">
        est un nom qui a pour <em>vocation</em> de devenir <em>un emblème.</em>
        <br />
        <em className="animate-embleme" id="embleme-1">
          Un emblème <span className="embleme">sportif,</span>
        </em>
        <br />
        <em className="animate-embleme" id="embleme-2">
          Un emblème <span className="embleme">qui rassemble,</span>
        </em>
        <br />
        <em className="animate-embleme" id="embleme-3">
          Un emblème <span className="embleme">qui ouvre des portes,</span>
        </em>
        <br />
        <em className="animate-embleme" id="embleme-4">
          Un emblème <span className="embleme">qui aide !</span>
        </em>
      </Paragraph>
      <p className="paragraph" id="advantages">
        Bénéficie <em>d'avantages exclusifs</em> en rejoignant la waiting list :
      </p>
      <ul id="advantages-list">
        <li>
          <span className="emoji">🙋</span>
          <span className="sentence-start">
            Participe au développement du projet
          </span>{" "}
          en suggérant des sports vers lequels se tourner.
        </li>
        <li>
          <span className="emoji">📝</span>
          <span className="sentence-start">
            Laisse ta marque de soutien
          </span>{" "}
          sur la page principale du site web.
        </li>
        <li>
          <span className="emoji">📬</span>
          <span className="sentence-start">
            Reçois des mises à jour exclusives
          </span>{" "}
          sur l'avancée du projet.
        </li>
        <li>
          <span className="emoji">🎁</span>Obtient une chance de{" "}
          <span className="sentence-start">
            bénéficier d'avantages exclusifs
          </span>{" "}
          lors d'événements.
        </li>
      </ul>
      <AnimateOnScroll
        setAnimate={setAnimateNumber}
        offset={1}
        selector="#already-signed-counter"
      >
        <div id="already-signed-counter">
          <h3>
            <span className="underlined">
              <em>{counter}</em> personnes
            </span>{" "}
            font déjà partie du projet et ont créé leur compte, alors pourquoi
            pas toi ?
          </h3>
        </div>
      </AnimateOnScroll>
      <PrimaryButton link="/account">Rejoindre</PrimaryButton>
    </section>
  );
};

export default JoinPage;
